// src/pages/auth/LoginRegisterPage.js
import React from "react";
import AuthForm from "../../components/auth/AuthForm";
import GoogleLoginButton from "../../components/auth/GoogleLoginButton";
import "../../styles/global.css";
import logo from "../../assets/images/myassessment.ai_logo.png";

const LoginRegisterPage = () => {
  return (
    <div className=" bg-gif relative flex flex-col items-center justify-center w-full h-screen overflow-hidden">
      {/* <video
        autoPlay
        loop
        muted
        playsInline
        className="absolute top-0 left-0 w-full h-full object-cover -z-10"
      >
        <source src="/MyAssessmentVdo.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video> */}

      <div className="lg:w-1/3 md:w-8/12 w-11/12 mx-auto inner-container rounded-[10%] border-2 shadow-lg shadow-purple-400 md:pt-14 pt-2 bg-white">
        <img
          src={logo}
          alt="MyAssessment.AI, Smarter Evaluations, Better Insights."
          aria-label="MyAssessment.AI, Smarter Evaluations, Better Insights."
          className="md:w-[200px] md:h-[72px] w-[140px] h-[55px] mx-auto"
        />
        <h1 className="md:pt-5 pt-2 md:text-lg text-sm text-center">Login to MyAssessment.ai</h1>
        <div className="md:mb-5 mb-0 text-center ">
          <h2 className="pt-5 text-2xl"></h2>
        </div>

        <div className="mid-container text-center">
          <p className="md:mb-5"></p>
          <div className="md:w-6/12 w-9/12 mx-auto mb-2">
            <GoogleLoginButton />
          </div>
          <p className="text-xs md:text-lg">OR</p>
          <div className="md:w-8/12  mx-auto">
            <AuthForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginRegisterPage;
